var map = {
	"./symbol_0.png": "e7d9",
	"./symbol_1.png": "e2cd",
	"./symbol_10.png": "f0a7",
	"./symbol_11.png": "12cb",
	"./symbol_12.png": "8b1e",
	"./symbol_2.png": "8592",
	"./symbol_3.png": "017d",
	"./symbol_4.png": "bc57",
	"./symbol_5.png": "bbeb",
	"./symbol_6.png": "9594",
	"./symbol_7.png": "66a1",
	"./symbol_8.png": "1086",
	"./symbol_9.png": "fd1c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84f8";